import { combineReducers } from 'redux';

import user from '../modules/profile/redux/userReducer';
import partnerBook from '../modules/partners/redux/partnerBookReducer';
import menu from '../modules/_shared/redux/menuReducer';
import sideNav from '../modules/_shared/redux/sideNavReducer';
import alerts from '../modules/_shared/redux/alertReducer';
import documents from '../modules/documents/redux/documentReducer';
import envelopes from '../modules/envelopes/redux/envelopeReducer';
import modal from '../modules/_shared/redux/modalReducer';
import society from '../modules/society/redux/societyReducer';
import plans from '../modules/beneficiaries/redux/planReducer';
import drafts from '../modules/drafts/redux/draftReducer';
import holdingClasses from '../modules/partners/redux/holdingClassReducer';
import tenderOffers from '../modules/transactions/redux/tenderOfferReducer';
import tenderOffersShares from '../modules/transactions/redux/tenderOfferSharesReducer';
import boards from '../modules/boards/redux/boardReducer';
import communications from '../modules/communications/redux/communicationReducer';
import preview from '../modules/_shared/redux/previewReducer';
import notification from '../modules/_shared/redux/notificationReducer';
import fullWidth from '../modules/_shared/redux/fullWidthReducer';
import employees from '../modules/beneficiaries/redux/employeesReducer';
import employeesPlans from '../modules/beneficiaries/redux/employeesPlanReducer';
import partnerCategories from '../modules/partners/redux/partnerCategoryReducer';
import partnerRepresentants from '../modules/partners/redux/partnerRepresentantsReducer';
import globalNotifications from '../modules/_shared/redux/globalNotificationReducer';
import guests from '../modules/society/redux/guestsReducer';
import committees from '../modules/administratives/redux/committeeReducer';
import councils from '../modules/administratives/redux/councilReducer';
import realties from '../modules/administratives/redux/realtyReducer';
import sharesTitles from '../modules/partners/redux/sharesTitlesReducer';
import partners from '../modules/partners/redux/partnerReducer';
import operations from '../modules/transactions/redux/operationReducer';
import shares from '../modules/partners/redux/sharesReducer';
import tradingOffers from '../modules/trading/redux/tradingOfferReducer';
import tradingOfferOperations from '../modules/trading/redux/tradingOfferOperationReducer';
import incentiveOffers from '../modules/incentivesMarket/redux/incentiveOfferReducer';
import incentiveOfferOperations from '../modules/incentivesMarket/redux/incentiveOfferOperationReducer';
import folders from '../modules/documents/redux/folderReducer';
import ai from '../modules/ai/redux/aiReducer';

const rootReducer = combineReducers({
  menu,
  sideNav,
  alerts,
  modal,
  user,
  society,
  partnerBook,
  documents,
  envelopes,
  plans,
  drafts,
  holdingClasses,
  tenderOffers,
  tenderOffersShares,
  boards,
  communications,
  preview,
  notification,
  fullWidth,
  employees,
  employeesPlans,
  partnerCategories,
  partnerRepresentants,
  globalNotifications,
  guests,
  committees,
  councils,
  realties,
  sharesTitles,
  partners,
  operations,
  shares,
  tradingOffers,
  tradingOfferOperations,
  incentiveOffers,
  incentiveOfferOperations,
  folders,
  ai,
});

export default rootReducer;
